/**
 * Created by Daniela on 29/11/2016.
 */
export class Obrigacao {
    ativo: boolean;
    dataVencimento: string;
    dataPagamento: string;
    observacao: string;
    tipoObrigacaoId: number;
    bemId: number;
    valor: number;
    id: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/shared/obrigacao.model.ts
 **/